// removed by extract-text-webpack-plugin
module.exports = {"header":"src-styles----header-module---header---1C-DW","image":"src-styles----header-module---image---2ijAT","links":"src-styles----header-module---links---uYR05","link":"src-styles----header-module---link---1EMsL","menu":"src-styles----header-module---menu---1Zp9j","menuPopup":"src-styles----header-module---menuPopup---2v0Xa"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/header.module.scss
// module id = 302
// module chunks = 114276838955818